module.exports = __webpack_public_path__ + "static/deb81ef9d3ff608bd0b515b725f0549146c1f7f42ba4b0af37c38a79592fa17d-a87fb7e6f7cf94597d42417ee77e8a37.png";